<form [formGroup]='formGroup' class='mb-2'>
  <div class='input-group input-group-sm input-group--treatment'>
    <label [htmlFor]='inputId' [innerHTML]='label' class="form-label"></label>
    <input [class.is-invalid]='isChanged && formGroup.invalid'
           [id]='inputId'
           autocomplete='off'
           class='form-control form-control-sm'
           formControlName='value'
           readonly
           type='text'>
    <div class='input-group-text'>
      <button (click)='riskAssessment.emit()'
              [disabled]='!enabled'
              class='btn btn-sm btn-primary min-width-60'>
        {{ 'BUTTON.RUN' | translate }}
      </button>
    </div>
  </div>
</form>
